import React from 'react';
import {
  ListItemIcon,
  ListItemText,
  Icon,
  Menu,
  MenuItem,
} from '@mui/material';
import classNames from "classnames";
import useLongPress from "../../utils/useLongPress";

import './AnchorMenu.scss';

const key = 'AnchorMenu';

const AnchorMenu = props => {
  const {
    className,
    anchorButton,
    menus,
    noRecordMessage,
    longPress,
    originVariant,

    pressCallback,
  } = props;

  const [menuAnchor, setMenuAnchor] = React.useState(null);

  const origin = {
    topRight: {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      }
    },
    topLeft: {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      }
    }
  };
  const originPayload = origin[originVariant];

  const handleClick = (event) => {
    event.currentTarget.blur();

    if (!longPress) {
      setMenuAnchor(event.target);
    }

    if (pressCallback) {
      pressCallback();
    }
  }
  const handleOnLongPress = useLongPress(({ target }) => {
    if (longPress) {
      setMenuAnchor(target)
    }
  }, handleClick);

  return (
    <>
      <section
        className={classNames(
          key,
          className,
          "no-swipe",
        )}
      >
        <div
          className="anchor-button"
          {...handleOnLongPress}
        >
          {anchorButton}
        </div>
        <div
          className="anchor-menu"
        >
          <Menu
            className={`${key}-menu`}
            open={!!menuAnchor}
            anchorEl={menuAnchor}
            onClose={() => setMenuAnchor(null)}
            anchorOrigin={originPayload?.anchorOrigin}
            transformOrigin={originPayload?.transformOrigin}
          >
            {menus.length === 0 && noRecordMessage && (
              <MenuItem
                className='menu-item box-shadow'
                onClick={() => {
                  setMenuAnchor(null);
                }}
              >
                {noRecordMessage}
              </MenuItem>
            )}

            {menus?.map((item, index) => (
              <MenuItem
                className='menu-item box-shadow'
                key={index}
                onClick={() => {
                  setMenuAnchor(null);
                  item.callback?.();
                }}
              >
                {item.icon && (
                  <ListItemIcon>
                    <Icon className="icon">{item.icon}</Icon>
                  </ListItemIcon>
                )}
                <ListItemText className="text" primary={item.label} />
              </MenuItem>
            ))}
          </Menu>
        </div>
      </section>
    </>
  );
};

export default AnchorMenu;